<div class="p-2 bg-sidebar br-8 d-flex gap-16 w-100" *ngIf="doc">
<!-- icone -->
<div (click)="goToDocument(doc)" class="pointer" title="Voir le document">
  <div class="br-8 aspect-ratio_1-1 hc_bg d-flex align-items-center justify-content-center" *ngIf="doc.name && doc.name == 'attestation logement'">
    <img src="../../../../assets/img/showcase/Landing1/services/housing-icon.svg" alt="">
  </div>
  <div class="position-relative" *ngIf="doc.name && doc.name != 'attestation logement'">
    <span class="material-icons id_box d-flex align-items-center justify-content-center txt-yellow-happy br-8" *ngIf="doc.name && doc.name == 'id photo'">person</span>
    <span class="material-icons certificate_box d-flex align-items-center justify-content-center text-success br-8" *ngIf="doc.name && doc.name == 'lettre d admission'">school</span>
    <span class="material-icons-outlined doc_icon d-flex align-items-center justify-content-center txt-dark-blue br-8" *ngIf="doc.name && doc.name !== 'id photo' && doc.name !== 'lettre d admission'">description</span>
    <span *ngIf="doc.state && doc.state !== 'validated'" class="newPastille" title="{{doc.state}}">!</span>
  </div>
</div>
<!-- doc info -->
  <div class="w-100 d-flex flex-column">

    <div class="d-flex justify-content-between w-100 align-items-center">

      <div class="semi-bold">{{ doc.name }}
        <div class="spinner-border spinner-border-sm v-middle ms-2" role="status" *ngIf="isRegenerating">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
      <div>
        <button class="btn border-0 p-0" mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
          <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #menu="matMenu">
          <button mat-menu-item (click)="goToDocument(doc)">Voir le document</button>
          <button mat-menu-item *ngIf="doc.name && doc.name != 'attestation logement' && doc.type" (click)="openModal(ReuploadModal)">Réuploader</button>
          <!-- <button mat-menu-item *ngIf="doc.name && doc.name == 'attestation logement'" (click)="regenerateHC()" [disabled]="isRegenerating">Regénérer</button> -->
          <button mat-menu-item *ngIf="doc.name && doc.name == 'attestation logement'" (click)="checkDocument(doc.accessKey, changeInfoModal);getPropertiesRefs()">
            Mettre à jour
          </button>
          <button mat-menu-item *ngIf="doc.name && doc.name == 'attestation logement'" (click)="checkDocument(doc.accessKey, changeValidityModal)" [disabled]="isRegenerating">Changer la date de validité</button>
          <button mat-menu-item class="text-danger" (click)="deleteAttachment(doc)">Supprimer</button>
        </mat-menu>
      </div>

    </div>

    <span class="mt-auto mediumGray">{{ doc.updated_at | date:'shortDate':'':'FR' }}</span>
  </div>

</div>



<!-- reupload -->
<ng-template #ReuploadModal let-modal>
  <div class="p-4">
    <div class="d-flex justify-content-between align-items-center mb-4">
      <h4>Reupload modal</h4>
      <button type="button" class="lightGray2 btn border-0" aria-label="Close" (click)="modal.close()">
        <span class="material-icons-outlined">close</span>
      </button>
    </div>
    <span>Reupload de <strong>{{ doc.name }}</strong></span>
    <app-upload-file class="w-100 mt-1 mb-3" (onUpload)="onFileUpload($event)"
                     [documentType]="doc['type']" [mode]="'single'" [userId]="doc.user_id"></app-upload-file>

    <p class="font-12">Les modifications sont effectives immédiatement. La page rechargera après upload d'un nouveau document.</p>

  </div>
</ng-template>

<!-- reupload -->
<ng-template #changeInfoModal let-modal>
  <div class="p-4">
    <div class="mb-4 ">
      <h4 class="d-flex justify-content-between title_4">
        Mettre à jour les informations
        <button type="button" class="lightGray2 btn border-0" aria-label="Close" (click)="modal.close()">
          <span class="material-icons-outlined">close</span>
        </button>
      </h4>
      <div>
        <div class="w-100 d-flex justify-content-center mt-4" *ngIf="!hasLoad">
          <div class="spinner-border text-primary"></div>
        </div>
        <form [formGroup]="form" (ngSubmit)="updateDocument()" id="updateUserForm" class="form-row w-100 align-items-center" *ngIf="hasLoad">
          <mat-form-field class="col-12" >
            <mat-label>Username <small>(Prénoms Nom)</small></mat-label>
            <input type="text" matInput [formControl]="form.controls.username" />
          </mat-form-field><br />
          <mat-form-field class="col-12" >
            <mat-label>Date de naissance <small>(yyyy-mm-dd)</small></mat-label>
            <input type="text" matInput [formControl]="form.controls.birthdate" />
          </mat-form-field><br />
          <mat-form-field class="col-12" >
            <mat-label>Lieu de naissance</mat-label>
            <input type="text" matInput [formControl]="form.controls.birthplace" />
          </mat-form-field><br />
          <div class="col-12 justify-content-start">
            <select2 class="w-100" #select2Element (update)="updateFormValues($event)" resettable displaySearchStatus="always" styleMode="material" [placeholder]="'Choix du logement (ID - Ville (Métropole) - Prix (HC) '" minCharForSearch="3" [data]="properties"></select2>
          </div>
          <mat-form-field  class="col-12">
            <mat-label>Loyer</mat-label>
            <input type="text" matInput [formControl]="form.controls.rent" readonly />
          </mat-form-field><br />
          <mat-form-field  class="col-12" >
            <mat-label>logement</mat-label>
            <input type="text" matInput [formControl]="form.controls.name" readonly />
          </mat-form-field><br />
          <mat-form-field  class="col-12" >
            <mat-label>Adresse</mat-label>
            <input type="text" matInput [formControl]="form.controls.address" readonly />
          </mat-form-field><br />
          <mat-form-field class="col-12">
            <mat-label>Date de début de bail</mat-label>
            <input matInput [matDatepicker]="picker" [formControl]="form.controls.arrivalDate">
            <mat-datepicker-toggle class="fixPosition" matIconSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>
          <mat-form-field class="col-12">
            <mat-label class="text-capitalize">Durée de séjour (mois)</mat-label>
            <input type="number" matInput [formControl]="form.controls.stayDuration" min="0" max="99"/>
          </mat-form-field>
          <button type="submit" class="col-12 btn btn-primary" *ngIf="!loading">Mettre à jour</button>
          <button type="submit" disabled class="col-12 btn btn-primary" *ngIf="loading">
            <div  class="spinner-border spinner-border-sm text-light" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </button>
        </form>
      </div>

    </div>

  </div>
</ng-template>


<!-- Change validity modal -->
<ng-template #changeValidityModal let-modal>
  <div class="p-4">
    <div class="mb-4 ">
      <h4 class="d-flex justify-content-between title_4">
        Changer la date de validité
        <button type="button" class="lightGray2 btn border-0" aria-label="Close" (click)="modal.close()">
          <span class="material-icons-outlined">close</span>
        </button>
      </h4>
      <div class="text-center">
        <div class="w-100 d-flex justify-content-center mt-4" *ngIf="!hasLoad">
          <div class="spinner-border text-primary"></div>
        </div>
        <form [formGroup]="form" (ngSubmit)="updateValidity()" id="updateValidityForm" class="form-row w-100 align-items-center" *ngIf="hasLoad">
          <mat-form-field class="col-12">
            <mat-label>Date de validité de l'attestation</mat-label>
            <input matInput [matDatepicker]="picker" [formControl]="form.controls.validity">
            <mat-datepicker-toggle class="fixPosition" matIconSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>
          <button type="submit" class="col-12 btn btn-primary" *ngIf="!loading">Valider</button>
          <button type="submit" disabled class="col-12 btn btn-primary" *ngIf="loading">
            <div  class="spinner-border spinner-border-sm text-light" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </button>
        </form>
      </div>

    </div>

  </div>
</ng-template>
